import { ColDef } from "ag-grid-community";
import { agGridEmptyColumnToFitEmptySpace } from "../../../../../../common/ag-grid/utils/constants/agGridEmptyColumnToFitEmptySpace";
import { SnowflakeConnectionNameCellRenderer } from "@/components/pages/integrations/components/provider-connections/snowflake/components/grid/cell-renderers/SnowflakeConnectionNameCellRenderer";
import { SnowflakeConnectionStatusCellRenderer } from "@/components/pages/integrations/components/provider-connections/snowflake/components/grid/cell-renderers/SnowflakeConnectionStatusCellRenderer";
import { SnowflakeConnectionConnectedByCellRenderer } from "@/components/pages/integrations/components/provider-connections/snowflake/components/grid/cell-renderers/SnowflakeConnectionConnectedByCellRenderer";
import { SnowflakeConnectionLastCollectedCellRenderer } from "@/components/pages/integrations/components/provider-connections/snowflake/components/grid/cell-renderers/SnowflakeConnectionLastCollectedCellRenderer";
import { SnowflakeConnectionActionCellRenderer } from "@/components/pages/integrations/components/provider-connections/snowflake/components/grid/cell-renderers/action-cell/SnowflakeConnectionActionCellRenderer";
import { slackConnectionConnectedByValueGetter } from "@/components/pages/integrations/components/provider-connections/snowflake/components/grid/value-getters/slackConnectionConnectedByValueGetter";
import { snowflakeConnectionLastCollectedValueGetter } from "@/components/pages/integrations/components/provider-connections/snowflake/components/grid/value-getters/slackConnectionLastCollectedValueGetter";
import { agGridActionColumnDefaultColumnDef } from "@/components/pages/common/ag-grid/utils/constants/agGridActionColumnDefaultColumnDef";

export const snowflakeConnectionGridColumns: ColDef[] = [
  {
    field: "name",
    headerName: "Account Name",
    minWidth: 200,
    cellRenderer: SnowflakeConnectionNameCellRenderer,
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 180,
    cellRenderer: SnowflakeConnectionStatusCellRenderer,
  },
  {
    field: "last_collected",
    headerName: "Last Collected",
    minWidth: 240,
    cellRenderer: SnowflakeConnectionLastCollectedCellRenderer,
    valueGetter: snowflakeConnectionLastCollectedValueGetter,
  },
  {
    field: "created_by",
    headerName: "Connected By",
    minWidth: 220,
    cellRenderer: SnowflakeConnectionConnectedByCellRenderer,
    valueGetter: slackConnectionConnectedByValueGetter,
  },
  agGridEmptyColumnToFitEmptySpace,
  {
    ...agGridActionColumnDefaultColumnDef,
    colId: "actions",
    width: 80,
    minWidth: 80,
    cellRenderer: SnowflakeConnectionActionCellRenderer,
  },
];
